import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';

import { cn } from '@/lib/utils';
import './button-style.scss';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  variant?:
    | 'basic-primary'
    | 'basic-secondary'
    | 'basic-success'
    | 'basic-danger'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'ghost-primary'
    | 'ghost-secondary'
    | 'ghost-success'
    | 'ghost-danger'
    | 'icon-primary'
    | 'icon-secondary'
    | 'icon-success'
    | 'icon-danger'
    | 'link-primary'
    | 'link-secondary'
    | 'link-success'
    | 'link-danger';
  size?: 'small' | 'medium';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    // Map variant to class name (add -button suffix for button variants, keep link- prefix for links)
    let variantClass = '';
    if (variant) {
      if (variant.startsWith('link-')) {
        // Link variants: link-primary -> link-primary (no -button suffix)
        variantClass = variant;
      } else {
        // Button variants: basic-primary -> basic-primary-button
        variantClass = `${variant}-button`;
      }
    }

    // Map size to existing button classes
    const sizeClass =
      size === 'small'
        ? 'small-button'
        : size === 'medium'
        ? 'medium-button'
        : '';

    return (
      <Comp
        className={cn(sizeClass, variantClass, className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = 'Button';

export { Button };
